import { LoadingButton } from "@mui/lab";
import {
	Box,
	Button,
	CardContent,
	Divider,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
} from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";
import { useAuthContext } from "src/components/Context/AuthContext/AuthContext";
import { useApiMutation } from "src/hooks/useApiMutation";

interface IProps {
	details: any;
	handleClose: Function;
}

const SingleProductUpdateForm = ({ details, handleClose }: IProps) => {
	const { user } = useAuthContext();
	const [status, setStatus] = useState<string>("");
	const { mutate, isSuccess, isPending } = useApiMutation({
		endPoint: `/api/fair/update-product/into-fair-member/${details?.fair_member_product_id}`,
		method: "PATCH",
		invalidateQueries: ["singleProduct", "exhibitorDetails"],
	});

	useEffect(() => {
		if (isSuccess) {
			handleClose();
		}
	}, [isSuccess]);
	const handleSubmit = async (event: ChangeEvent<HTMLFormElement>) => {
		event.preventDefault();
		const formData = new FormData();
		formData.append("user_fair_member_product_status", status);
		if (details.fair_member_product_id && status && user.user_admin_id) {
			mutate(formData);
		}
	};

	return (
		<>
			<Divider />
			{details && (
				<CardContent>
					<Box component='form' onSubmit={handleSubmit}>
						<Grid item xs={12}>
							<FormControl required fullWidth>
								<InputLabel
									required
									id='demo-simple-select-label'
								>
									Product Status
								</InputLabel>
								<Select
									id='outlined-required'
									defaultValue={
										details.user_fair_member_product_status &&
										details?.user_fair_member_product_status.toLowerCase()
									}
									label='                  Product Status
                  '
									required
									onChange={(e) => setStatus(e.target.value)}
								>
									<MenuItem value='approved'>
										Approved
									</MenuItem>
									<MenuItem value='pending'>Pending</MenuItem>
									<MenuItem value='rejected'>
										rejected
									</MenuItem>
								</Select>
							</FormControl>
						</Grid>
						{!isPending ? (
							<Button
								type='submit'
								fullWidth
								variant='contained'
								disableElevation
								sx={{
									mt: 3,
								}}
							>
								Update status
							</Button>
						) : (
							<LoadingButton
								loading
								fullWidth
								loadingIndicator='Updating...'
								variant='outlined'
								disableElevation
								sx={{
									mt: 3,
								}}
							>
								Updating...
							</LoadingButton>
						)}
					</Box>
				</CardContent>
			)}
		</>
	);
};

export default SingleProductUpdateForm;
